import { createStyles, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(
    createStyles({
        item: {
            marginBottom: 20,
        }
    })
)
